import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Typography, TextField, Box, Grid, Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getFormatoFechaExacta } from "../../../utils/getFormatoFecha";
import Hidden from "@mui/material/Hidden";

/* import principal from "../../images/header_1.png"; */
/* import principal from "../../images/imagen_header.gif"; */

import principal from "../../images/1.png";
import logo from "../../images/logo_tarifa.png";

import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  wrapper: {
    minHeight: "100vh",
    marginTop: "150px",
    background: "#fff",
    maxWidth: "1200px",
    marginLeft: "auto",
    marginRight: "auto",

    [theme.breakpoints.up("sm")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },
  },

  titulo: {
    fontSize: "4rem !important",
    lineHeight: "1 !important",
    fontWeight: "700 !important",
    marginTop: "140px !important",
    fontFamily: "Barlow",

    marginBottom: "40px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "3.25rem !important",
      marginTop: "10px !important",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "3.625rem !important",
      marginTop: "120px !important",
    },
  },

  subtitulos: {
    lineHeight: "1.75 !important",
    fontWeight: "400 !important",
    fontSize: "1.2rem !important",
    textAlign: "justify",
  },

  image: {
    maxWidth: "100%",
    verticalAlign: "middle",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
  },

  cardAgendar: {
    background: "rgba(255, 255, 255, 0.7)",
    margin: "auto !important",
    borderRadius: "5px",
  },
  boxSearch: {
    position: "absolute",
    bottom: "40%",
    [theme.breakpoints.down("md")]: {
      top: "10%",
    },
  },
  container: {
    marginTop: theme.spacing(6),
  },

  fullWidthInput: {
    width: "150px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },

  fullWidthSelect: {
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  esloganText: {
    width: "100%",
    marginBottom: "10px",
    padding: "30px",
    color: "white",
    fontWeight: "600",
    textShadow: "5px 5px 10px black",

    [theme.breakpoints.down("md")]: {
      marginBottom: "0px",
      padding: "10px",
    },
  },
  subEsloganText: {
    width: "100%",
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingBottom: "50px",
    color: "white",
    fontWeight: "600",
    textShadow: "5px 5px 10px black",

    [theme.breakpoints.down("md")]: {
      marginBottom: "0px",
      paddingLeft: "10%",
      paddingRight: "10%",
      padding: "10px",
    },
  },
  bttnEnviar: {
    height: "56px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  logoTarifa: {
    margin: "auto",
  },
  tipoDeCambio: {
    fontSize: "1.3rem !important",
    cursor: "default !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: ".9rem !important",
    },
  },
  stackOver: {
    bottom: "20px",
    [theme.breakpoints.down("sm")]: {
      bottom: "5px",
    },
  },
});

function HeadSection(props) {
  const {
    classes,
    theme,
    width,
    addLead,
    errors,
    landing,
    inicio,
    pushMessageToSnackbar,
    servicios,
    idioma,
    handleScrollClick,
    messages,
  } = props;

  const manana = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

  return (
    <Fragment>
      <div
        className={classNames("lg-p-top crossfade", classes.wrapper)}
        ref={inicio}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={5} alignContent="center">
            <div className={classes.logoTarifa}>
              <LazyLoadImage
                alt="Tarifa empresarial"
                src={logo} // use normal <img> attributes as props
                width="100%"
                effect="blur"
                delayMethod="debounce"
                style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "100%",
                }}
              />
            </div>

            <Typography
              variant="p"
              className={classes.subtitulos}
              sx={{ marginTop: "20px", display: "block" }}
            >
              {messages.texto_header_descripcion}
            </Typography>

            <Button
              variant="contained"
              sx={{
                display: "block",
                marginTop: "25px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              size="large"
              onClick={() => {
                handleScrollClick(servicios);
              }}
            >
              {messages.consultar_tigie}
            </Button>
          </Grid>
          <Hidden smDown>
            <Grid item xs={12} md={6} lg={7}>
              <LazyLoadImage
                alt="Tarifa empresarial"
                src={principal} // use normal <img> attributes as props
                height="100%"
                width="100%"
                effect="opacity"
                delayMethod="debounce"
              />
            </Grid>
          </Hidden>
        </Grid>
        {landing &&
        landing.indicadores &&
        landing.indicadores.length > 0 &&
        landing.indicadoresDos &&
        landing.indicadoresDos.length > 0 ? (
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            className={classes.stackOver}
            sx={{
              padding: "20px 20px",
              marginLeft: "auto",
              marginRight: "auto",
              width: "fit-content",
              position: "absolute",
              left: "0",
              right: "0",
            }}
          >
            {landing.indicadores &&
            landing.indicadores.filter(
              (indicador) => indicador.codTipoIndicador === 158
            ).length === 1 ? (
              <Button
                color="primary"
                variant="contained"
                className={classes.tipoDeCambio}
              >
                <strong>
                  {`${messages.tipo_de_cambio} ${getFormatoFechaExacta(
                    new Date(),
                    idioma
                  )}`}
                  :
                </strong>
                {"    "}
                {
                  landing.indicadores.filter(
                    (indicador) => indicador.codTipoIndicador === 158
                  )[0].valor
                }
              </Button>
            ) : (
              ""
            )}

            {landing.indicadoresDos &&
            landing.indicadoresDos.filter(
              (indicador) => indicador.codTipoIndicador === 158
            ).length === 1 ? (
              <Button
                color="primary"
                variant="contained"
                className={classes.tipoDeCambio}
              >
                <strong>
                  {`${messages.tipo_de_cambio} ${getFormatoFechaExacta(
                    manana,
                    idioma
                  )}`}
                  :
                </strong>
                {"    "}
                {
                  landing.indicadoresDos.filter(
                    (indicador) => indicador.codTipoIndicador === 158
                  )[0].valor
                }
              </Button>
            ) : (
              ""
            )}
          </Stack>
        ) : (
          ""
        )}
      </div>
    </Fragment>
  );
}

HeadSection.propTypes = {
  classes: PropTypes.object,
  errors: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  landing: PropTypes.object.isRequired,
  addLead: PropTypes.func.isRequired,
  width: PropTypes.string,
  theme: PropTypes.object,
  pushMessageToSnackbar: PropTypes.func,
  handleScrollClick: PropTypes.func.isRequired,
  servicios: PropTypes.object.isRequired,
  idioma: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(HeadSection);
